export default __webpack_public_path__ + "static/media/rezy_icon.bff2707f.ico";